import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { completeSendAnEmail } from '../actions/completeSendAnEmail';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { getStore } from '../store/store';

orchestrator(completeSendAnEmail, () => {
    let tasks = getStore().tasks;
    if (tasks && GetStartedTaskId.SendAnEmail in tasks) {
        completeGetStartedTask(GetStartedTaskId.SendAnEmail);
    }
});
